// DS: C59
/** A floating panel with links to share a deviation on social media */
import React from 'react';
import { useTranslation } from 'react-i18next';
import DesktopShareContent from './DesktopShareContent';
import s from './DesktopSharePopup.scss';
var DesktopSharePopup = function (_a) {
    var url = _a.url, title = _a.title, embedCode = _a.embedCode, media = _a.media, biData = _a.biData, requestClose = _a.requestClose;
    var t = useTranslation().t;
    return (React.createElement("div", { className: s['root'] },
        React.createElement("div", { className: s['title'] }, t('share.shareOnSocial')),
        React.createElement(DesktopShareContent, { url: url, title: title, embedCode: embedCode, media: media, biData: biData, requestClose: requestClose })));
};
DesktopSharePopup.displayName = 'DesktopSharePopup';
export default DesktopSharePopup;
//# sourceMappingURL=DesktopSharePopup.js.map